import React, { Fragment, useState } from 'react';
import { IconButton, TableCell, TableRow } from '@mui/material';
import Iconify from 'src/components/iconify';
import { Stack } from '@mui/system';
import DetailsModelTableRow from '../details-model-table-row';
import rowColors from './utils/details-model-colors';

const { rowColor1, rowColor2, rowColor3 } = rowColors;

const CalcBreakdownRows = ({ breakdownValues, title, costs, hideDetails }) => {
  const [selectedPercentages, setSelectedPercentages] = useState({});

  return (
    <>
      {breakdownValues.map((item, index) => (
        <Fragment key={index}>
          <TableRow sx={{ backgroundColor: rowColor2 }}>
            <TableCell>
              <Stack
                direction="row"
                sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <b>{item?.category?.title}</b>

                <IconButton
                  onClick={() =>
                    setSelectedPercentages((prev) => ({
                      ...prev,
                      [index]: !prev[index],
                    }))
                  }
                  sx={{
                    margin: '5px 10px',
                    fontSize: 25,
                  }}
                >
                  <Iconify
                    icon={`${
                      selectedPercentages[index] ? 'mingcute:up-line' : 'mingcute:down-line'
                    }`}
                  />
                </IconButton>
              </Stack>
            </TableCell>
            {hideDetails ? (
              <TableCell>{item?.category?.values[item?.category?.values.length - 1]}%</TableCell>
            ) : (
              item?.category?.values?.map((value, i) => <TableCell key={i}>{value}%</TableCell>)
            )}
          </TableRow>

          {selectedPercentages[index] &&
            item?.breakdown?.map((value, i) => (
              <DetailsModelTableRow
                key={i}
                title={value?.title}
                values={value?.values?.map((value) => `$${value.toFixed(2)}`)}
                hideDetails={hideDetails}
              />
            ))}
        </Fragment>
      ))}

      {/* Total Cost */}
      <DetailsModelTableRow
        title={title}
        values={costs.map((item) => `$${item.toFixed(2)}`)}
        bgColor={rowColor3}
        boldValues={true}
        hideDetails={hideDetails}
      />
    </>
  );
};

export default CalcBreakdownRows;
